import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Triangle extends Symbol2d {

  handles = [{
    defaults: [.5, 0],
    constraints: [
      [0, 1], null
    ],
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const _path = path()
    const tip = dimensions.width * (handles[0][0])

    _path.moveTo(tip, 0)
    _path.lineTo(dimensions.width, dimensions.height)
    _path.lineTo(0, dimensions.height)
    _path.lineTo(tip, 0)
    _path.closePath()
    return _path.toString()
  }

  textContainer (dimensions, handles) {
    const a = [dimensions.width * (handles[0][0]), 0] // tip
    const b = [dimensions.width, dimensions.height] // lower right
    const c = [0, dimensions.height] // lower left

    // Find the midpoints of the triangle's sides
    const mid1 = [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]
    const mid2 = [(a[0] + c[0]) / 2, (a[1] + c[1]) / 2]

    // Define the rectangle's width and height as the distance between the midpoints
    const width = mid1[0] - mid2[0]
    const height = dimensions.height - mid1[1] // the midpoints share the same y-coordinate

    return {
      width,
      height,
      center: [
        mid2[0] + width / 2,
        mid1[1] + height / 2
      ]
    }
  }
}
